module.exports = __webpack_public_path__ + "static/img/logo.cebd9fd0.png";